import React from 'react';
import { FilePreview } from './components/FilePreview';
import './index.css';

const App: React.FC = () => {
  return <FilePreview />;
};

export default App;
